import { useAdminSelector } from 'admin/reducers';
import { selectTraverseTreeData } from 'admin/reducers/card-editor-extra/selectors';

/**
 * Collects existing AI prompt keys to prevent duplicates.
 * Filters by group reference if provided, otherwise collects non-group keys.
 */
export const useCardAiTemplateKeys = (currentGroupRef: string | undefined, ignoredComponentId?: string) => {
	const traverseTreeData = useAdminSelector(selectTraverseTreeData);
	const aiTemplateKeys = new Set<string>();

	(traverseTreeData?.tree.card.components ?? []).forEach(item => {
		const aiTemplate = item.uiConfig.componentProps?.aiTemplate;
		if (aiTemplate && item._id !== ignoredComponentId) {
			if (currentGroupRef) {
				// Collect keys from specified group
				if (aiTemplate.ref === currentGroupRef) {
					aiTemplateKeys.add(aiTemplate.key);
				}
			} else if (!aiTemplate.ref) {
				// Collect keys from non-group elements
				aiTemplateKeys.add(aiTemplate.key);
			}
		}
	});

	return aiTemplateKeys;
};
